import { AxiosProgressEvent, AxiosResponse } from 'axios';

import { client } from '../client';

import { healthEndPoints } from './endpoints';
import {
  FinalizeMigrationHealthQuoteRequest,
  FinalizeMigrationHealthQuoteResponse,
  HealthCoverSuggestionRequest,
  HealthCoverSuggestionResponse,
  HealthEstimateRequest,
  HealthEstimateResponse,
  HealthPincodeValidationRequest,
  HealthPincodeValidationResponse,
  HealthPincodeVerificationRequest,
  HealthPincodeVerificationResponse,
  HealthPremiumRequest,
  HealthPremiumResponse,
  HealthProductBoundariesRequest,
  HealthProductBoundariesResponse,
  HealthProductFeaturesResponse,
  HealthQuoteFinalizeRequest,
  HealthQuoteFinalizeResponse,
  OptimaSecureMigrationPremiumRequest,
  HealthMigrationRequest,
  HealthMigrationResponse,
  HealthMigrationPremiumResponse
} from './types';

export const healthQuoteAPIs = {
  verifyHealthPincode: (
    payload: HealthPincodeVerificationRequest
  ): Promise<AxiosResponse<HealthPincodeVerificationResponse>> => {
    return client.get<HealthPincodeVerificationResponse>(
      healthEndPoints.verifyPincode,
      payload
    );
  },
  validateHealthPincode: (
    payload: HealthPincodeValidationRequest
  ): Promise<AxiosResponse<HealthPincodeValidationResponse>> => {
    return client.get<HealthPincodeValidationResponse>(
      healthEndPoints.validatePincode,
      payload
    );
  },
  getHealthProductBoundaries: (
    payload: HealthProductBoundariesRequest
  ): Promise<
    AxiosResponse<HealthProductBoundariesResponse, HealthProductBoundariesRequest>
  > => {
    return client.post<
      HealthProductBoundariesResponse,
      HealthProductBoundariesRequest
    >(healthEndPoints.boundaries, payload);
  },
  getHealthSuggestions: (
    payload: HealthCoverSuggestionRequest
  ): Promise<
    AxiosResponse<HealthCoverSuggestionResponse, HealthCoverSuggestionRequest>
  > => {
    return client.post<HealthCoverSuggestionResponse, HealthCoverSuggestionRequest>(
      healthEndPoints.suggestion,
      payload
    );
  },
  getHealthEstimate: (
    payload: HealthEstimateRequest
  ): Promise<AxiosResponse<HealthEstimateResponse, HealthEstimateRequest>> => {
    return client.post<HealthEstimateResponse, HealthEstimateRequest>(
      healthEndPoints.estimate,
      payload
    );
  },
  getHealthProductFeatures: (
    payload: HealthProductBoundariesRequest
  ): Promise<
    AxiosResponse<HealthProductFeaturesResponse, HealthProductBoundariesRequest>
  > => {
    return client.post<
      HealthProductFeaturesResponse,
      HealthProductBoundariesRequest
    >(healthEndPoints.features, payload);
  },
  getHealthPremium: (
    payload: HealthPremiumRequest,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
    onDownloadProgress?: (progressEvent: AxiosProgressEvent) => void
  ): Promise<AxiosResponse<HealthPremiumResponse, HealthPremiumRequest>> => {
    return client.post<HealthPremiumResponse, HealthPremiumRequest>(
      healthEndPoints.premium,
      payload,
      {
        onUploadProgress,
        onDownloadProgress
      }
    );
  },
  finalizeHealthQuote: (
    payload: HealthQuoteFinalizeRequest
  ): Promise<
    AxiosResponse<HealthQuoteFinalizeResponse, HealthQuoteFinalizeRequest>
  > => {
    return client.post<HealthQuoteFinalizeResponse, HealthQuoteFinalizeRequest>(
      healthEndPoints.finalize,
      payload
    );
  },
  getPolicyInformationForHealthMigration: (
    payload: HealthMigrationRequest
  ): Promise<AxiosResponse<HealthMigrationResponse>> => {
    return client.get<HealthMigrationResponse>(healthEndPoints.policyInfo, payload);
  },
  getRenewalPremium: (
    payload: OptimaSecureMigrationPremiumRequest
  ): Promise<
    AxiosResponse<
      HealthMigrationPremiumResponse,
      OptimaSecureMigrationPremiumRequest
    >
  > => {
    return client.post<
      HealthMigrationPremiumResponse,
      OptimaSecureMigrationPremiumRequest
    >(healthEndPoints.healthRenewalPremium, payload);
  },
  finalizeMigrationHealthQuote: (
    payload: FinalizeMigrationHealthQuoteRequest
  ): Promise<
    AxiosResponse<
      FinalizeMigrationHealthQuoteResponse,
      FinalizeMigrationHealthQuoteRequest
    >
  > => {
    return client.post<
      FinalizeMigrationHealthQuoteResponse,
      FinalizeMigrationHealthQuoteRequest
    >(healthEndPoints.finalizeMigrationHealthQuote, payload);
  }
};
